import { render, staticRenderFns } from "./HeaderCurrency.vue?vue&type=template&id=e57209e0&"
import script from "./HeaderCurrency.vue?vue&type=script&lang=ts&"
export * from "./HeaderCurrency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports